import React, { useEffect, useState } from "react"
import { graphql } from "gatsby"
import parse from "html-react-parser"
import { Asset } from "../../../../plugins/gatsby-plugin-atollon"
import StructuredText from "../custom-structured-text-renderer"
import { RightArrow } from "../../icons"

const TitleContentColumn = ({ title, richContent, items }) => {
  const [activeIndex, setActiveIndex] = useState(null)
  const activeItem = activeIndex !== null ? items?.[activeIndex] : null

  useEffect(() => {
    if (activeIndex === null) return

    const onKey = (e) => {
      if (e.key === "Escape") setActiveIndex(null)
    }

    document.addEventListener("keydown", onKey)
    document.body.style.overflow = "hidden"

    return () => {
      document.removeEventListener("keydown", onKey)
      document.body.style.overflow = ""
    }
  }, [activeIndex])

  return (
    <>
      <section className="title-content-column">
        <div className="title-content-column__inner">
          <div className="title-content-column__header">
            {title && <h2>{parse(title)}</h2>}
            {richContent && <StructuredText data={richContent} />}
          </div>

          <div className="title-content-column__items">
            {items?.length > 0 &&
              items.map((el, i) => (
                <div
                  key={i}
                  className="title-content-column__item"
                  data-sal="slide-up"
                  data-sal-duration="1000"
                  data-sal-easing="ease"
                >
                  <div className="title-content-column__item-image">
                    {el.image && <Asset asset={el.image} />}
                  </div>

                  {el.title && <h3>{el.title}</h3>}
                  {el.excerpt && <StructuredText data={el.excerpt} />}
                  <button onClick={() => setActiveIndex(i)}>
                    Learn More
                    <RightArrow color="#0D2E7A" />
                  </button>
                </div>
              ))}
          </div>
        </div>
      </section>

      <div
        className={`title-content-column__popup ${activeItem ? "title-content-column__popup--active" : ""}`}
        onClick={() => setActiveIndex(null)}
        role="presentation"
      >
        {activeItem && (
          <div
            className="title-content-column__popup-inner"
            onClick={(e) => e.stopPropagation()}
            role="dialog"
            aria-modal="true"
          >
            <button onClick={() => setActiveIndex(null)}>
              <svg
                width="36"
                height="36"
                viewBox="0 0 36 36"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="18" cy="18" r="18" fill="#154782" />
                <path
                  d="M24.4286 11.5714L11.5714 24.4286M11.5714 11.5714L24.4286 24.4286"
                  stroke="white"
                  stroke-width="1.60714"
                  stroke-linecap="square"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
            <div className="title-content-column__popup-content">
              {activeItem.title && <h3>{activeItem.title}</h3>}
              {activeItem.richContent && (
                <div className="content">
                  <StructuredText data={activeItem.richContent} />
                </div>
              )}
            </div>

            {activeItem.image && (
              <div className="title-content-column__popup-image">
                <Asset asset={activeItem.image} />
              </div>
            )}
          </div>
        )}
      </div>
    </>
  )
}

export default TitleContentColumn

export const query = graphql`
  fragment TitleContentColumnProps on DatoCmsTitleContentColumn {
    ... on DatoCmsTitleContentColumn {
      id
      title
      richContent {
        value
      }
      items {
        title
        excerpt {
          value
        }
        richContent {
          value
        }
        image {
          ...InternalAssetProps
        }
        button {
          ...LinkWithTitleProps
        }
      }
    }
  }
`
